import {
    ADD_DEPOTS,
    GET_DEPOTS_LIST,
    DEPOTS_LIST_RESPONCE,
    EDIT_DEPOTS,
    EDIT_DEPOTS_STATUS,
    DELETE_DEPOTS,
    EDIT_DEPOTS_REDUX_STATE,
    DELETE_DEPOTS_REDUX_STATE,
    EDIT_DEPOTS_STATUS_REDUX_STATE
} from "./actionTypes";

/**
 * Action creator function that creates an action to add depots.
 * @param {any} data - The data to be added as depots.
 * @param {string} token - The token for authentication.
 * @param {function} success - The success callback function.
 * @param {function} failure - The failure callback function.
 * @returns {object} An action object with type, payload, success, and failure properties.
 */
export const addDepots = (data, success, failure) => {
  return {
    type: ADD_DEPOTS,
    payload: { data },
    success: (data) => success(data),
    failure: (data) => failure(data),
  }
  }

/**
 * Returns an action object to get the list of depots.
 * @param {string} token - The authentication token.
 * @param {function} success - The success callback function.
 * @param {function} failure - The failure callback function.
 * @returns {object} - An action object with type, payload, success, and failure properties.
 */
export const getDepotsList = (data,success, failure) => {
  return {
    type: GET_DEPOTS_LIST,
    payload: { data },
    success: (data) => success(data),
    failure: (data) => failure(data),
  }
  }

/**
 * Action creator function that returns an action object for a successful retrieval of depots list.
 * @param {any} data - The data received from the API call.
 * @returns {object} An action object with type and payload properties.
 */
export const depotsListResponce = data => {
  return {
    type: DEPOTS_LIST_RESPONCE,
    payload: data,
  }
}

/**
 * Action creator function that creates an action to edit depots.
 * @param {string} id - The ID of the depot to edit.
 * @param {object} data - The data to update the depot with.
 * @param {string} token - The authentication token.
 * @param {function} success - The success callback function.
 * @param {function} failure - The failure callback function.
 * @returns {object} An action object with type, payload, success, and failure properties.
 */
export const editDepots = (id, data, success, failure) => {
  return {
    type: EDIT_DEPOTS,
    payload: { id, data},
    success: (data) => success(data),
    failure: (data) => failure(data),
  }
}

/**
 * Action creator function for editing the status of a depot.
 * @param {number} id - The ID of the depot to edit.
 * @param {object} data - The data to update the depot with.
 * @param {string} token - The authentication token.
 * @param {function} success - The success callback function.
 * @param {function} failure - The failure callback function.
 * @returns An action object with the type, payload, success, and failure properties.
 */
export const depotsEditStatus = (id, data, success, failure) => {
  return {
    type: EDIT_DEPOTS_STATUS,
    payload: { id, data},
    success: (data) => success(data),
    failure: (data) => failure(data),
  }
}

/**
 * Action creator for deleting a depot.
 * @param {number} id - The ID of the depot to delete.
 * @param {object} data - Additional data to include in the payload.
 * @param {string} token - The authentication token.
 * @param {function} success - Callback function to be called on successful deletion.
 * @param {function} failure - Callback function to be called on deletion failure.
 * @returns {object} An action object with type, payload, success, and failure properties.
 */
export const depotsDelete = (id, success, failure) => {
  return {
    type: DELETE_DEPOTS,
    payload: { id },
    success: (data) => success(data),
    failure: (data) => failure(data),
  }
}


// redux Actions

/**
 * Action creator function for editing the Redux state.
 * @param {any} data - The data to be updated in the Redux state.
 * @returns {object} An action object with the type and payload properties.
 */
export const editDepotsReduxState = (data) => {
  return {
    type: EDIT_DEPOTS_REDUX_STATE,
    payload: data,
  }
}

 /**
  * Action creator function to delete Redux state.
  * @param {any} data - The data to be passed as the payload of the action.
  * @returns {object} An action object with type DELETE_REDUX_STATE and the provided data as the payload.
  */
 export const deleteDepotsReduxState = (data) => {
  return {
    type: DELETE_DEPOTS_REDUX_STATE,
    payload: data,
  } 
}

/**
 * Action creator function to edit the status in the Redux state.
 * @param {any} data - The data to be updated in the Redux state.
 * @returns {object} - An action object with the type and payload.
 */
export const editDepotsStatusReduxState = (data) => {
  return {
    type: EDIT_DEPOTS_STATUS_REDUX_STATE,
    payload: data,
  }
}